import { Component, OnInit, DoCheck, ViewEncapsulation, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { appVariables } from '../../../../app.constants';
import { OrdersService } from '../../shared/orders.service';
import { UserService } from '../../../../core/user.service';
import { IUserTerritoryFromAPI } from '../../../../core/interfaces/app.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslationService } from '../../../../core/translation.service';
import { SidenavService } from '../../../../shared/sidenav.service';
import * as _ from 'lodash';
import { MatSidenav } from '@angular/material/sidenav';
import {  MatDialog,  MatDialogRef,  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HighlightDirective } from './highlight.directive';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/core/auth.service';
const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
@Component({
  selector: 'app-title',
  encapsulation: ViewEncapsulation.None,
  templateUrl: `./title.component.html`,
  styleUrls: ['./title.component.scss']
})
export class TitleComponent implements OnInit, DoCheck {

  @ViewChild('settingsSideNav') public settingsSideNav: MatSidenav;

  enableBackArrow = false;
  ntauSearchOptions: {
    itemKey: string, itemValue: string, placeHolder: string, searchTextValue: string, focus: boolean,
    innerSearch: { itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string }[]
  }[];
  mtauLabelOptions: { isLabelRequired: boolean, labelValue: string };
  mtauOptions: { name: string, optionsDisplayname: string, value: any }[] = [];
  mtauSelectedOption: { name: string, optionsDisplayname: string, value: any };
  isTerritoryUser = false;
  isMultipleTerritoryUser = false;
  ntauSelectedSalesOrg: { itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string } |undefined;
  actions: Subject<string> = new Subject<string>();
  startTime: string;
  endTime: string;

  constructor(private cd: ChangeDetectorRef, private ordersService: OrdersService, public userService: UserService, public router: Router,
    private translationService: TranslationService, private activatedRoute: ActivatedRoute, 
    private sidenavService: SidenavService, public dialog: MatDialog,
    private authService: AuthService) { }

  ngDoCheck(): void {
    this.enableBackArrow = this.router.url.includes('orders') || this.router.url.includes('products');
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogContentExampleDialog, { panelClass: 'custom-dialog-container' });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  getTime(timeDetals: string) {
    let dateInfo = timeDetals.split(" ")[0];
    const d = new Date(dateInfo);
    let date = d.getDate();
    let month = months[d.getMonth()];
    let timeInfo = timeDetals.split(" ")[1];
    let timeVal = timeInfo.split(":");
    let time = timeVal[0] + ':' + timeVal[1];
    let timeHour = parseInt(timeVal[0]);
    let timeReference = "";
    if(timeHour >= 12){
      timeReference = "pm"
    }else{
      timeReference = "am"
    }
    return `${date} ${month} ${time} ${timeReference}`
  }

  ngOnInit(): void {
    if (this.userService.currentUser.isTerritoryManager) {
      this.isTerritoryUser = true;
      if (this.userService.currentUser.territories.length > 1) {
        this.mtauLabelOptions = { isLabelRequired: true, labelValue: 'ATHENA_WEB_UI.ORDERS.TITLE.TERRITORY_NO' };
        _.each(this.userService.currentUser.territories, (item: IUserTerritoryFromAPI) => {
          this.mtauOptions.push({ name: item.territoryId, optionsDisplayname: `Territory# ${item.territoryId}`, value: item });
        });
        this.mtauSelectedOption = this.mtauOptions[0];
        this.isMultipleTerritoryUser = true;
        this.ordersService.sourceValueOfOrdersView$.next({
          search: {
            searchKey: 'territory', searchValue: {
              territoryId: this.mtauSelectedOption.value.territoryId, systemId: this.mtauSelectedOption.value.systemId
            }
          }
        });
      } else {
        this.ordersService.sourceValueOfOrdersView$.next({
          search: {
            searchKey: 'territory', searchValue: {
              territoryId: this.userService.currentUser.territories[0].territoryId, systemId: this.userService.currentUser.territories[0].systemId
            }
          }
        });
      }
      this.ordersService.canReload = true;
      this.router.navigate(['/orderStatus/customers']);
    } else {
      // Changes for new institutional route config goes here
      const routerParam = sessionStorage.getItem(appVariables.guids.paramGUID);
      const queryParam = sessionStorage.getItem(appVariables.guids.searchGUID);
      sessionStorage.removeItem(appVariables.guids.paramGUID);
      sessionStorage.removeItem(appVariables.guids.searchGUID);
      if (routerParam && queryParam) {
        this.ntauSelectedSalesOrg = _.find(appVariables.orders.title.ntauSalesOrg, ['itemCode', queryParam.toUpperCase()]);
        if (this.ntauSelectedSalesOrg) {
          this.ntauSearchOptions = [
            {
              itemKey: appVariables.orders.title.ntauSearchKeys[1], itemValue: appVariables.orders.title.ntauSearchOptions[1],
              placeHolder: appVariables.orders.title.ntauSearchOptionsPlaceHolders[1], searchTextValue: routerParam, focus: false,
              innerSearch: _.sortBy(appVariables.orders.title.ntauSalesOrg, ['itemValue'])
            }
          ];
          this.ordersService.canReload = true;
          // Set the step index so that orders can be viewed for the particular shipTo
          this.ordersService.moveToStep = 2;
          this.ordersService.sourceValueOfOrdersView$.next({
            search: {
              searchKey: 'customer',
              searchValue: { shipToNo: routerParam, salesOrg: this.ntauSelectedSalesOrg.itemKey }
            }
          });
          this.router.navigate(['/orderStatus/customers']);
        } else {
          this.defaultNtauSearch();
        }
      } else {
        this.defaultNtauSearch();
      }
    }
    // this.authService.checkScheduledMaintainance().subscribe((res: any) =>{
    //   if(res && res.maintainanceTime && res.maintainanceTime[0]){
    //     this.startTime = this.getTime(res.maintainanceTime[0].startTime);
    //     this.endTime = this.getTime(res.maintainanceTime[0].endTime);
    //   }
    // }, (error: any) => {
    //   if (error) {
    //     console.log("err", error);
    //   }
    // });
  }

  ngAfterViewInit() {
    this.sidenavService.setSidenav(this.settingsSideNav, false);
    this.cd.detectChanges();
  }

  defaultNtauSearch() {
    this.ntauSelectedSalesOrg = JSON.parse(localStorage.getItem(appVariables.orders.title.salesOrgGUID)!);
    this.ntauSearchOptions = [
      {
        itemKey: appVariables.orders.title.ntauSearchKeys[1], itemValue: appVariables.orders.title.ntauSearchOptions[1],
        placeHolder: appVariables.orders.title.ntauSearchOptionsPlaceHolders[1], searchTextValue: '', focus: false,
        innerSearch: _.sortBy(appVariables.orders.title.ntauSalesOrg, ['itemValue'])
      }
    ];
  }

  toggleSideNav() {
    this.sidenavService.toggle(false);
    this.cd.detectChanges();
  }

  onTerritorySelectionChange(event: any) {
    this.mtauSelectedOption = event;
    this.ordersService.canReload = true;
    this.ordersService.sourceValueOfOrdersView$.next({
      search: {
        searchKey: 'territory', searchValue: {
          territoryId: this.mtauSelectedOption.value.territoryId, systemId: this.mtauSelectedOption.value.systemId
        }
      }
    });
    if (!(this.router.url.includes('customers'))) {
      this.router.navigate(['/orderStatus/customers']);
    }
  }

  userSearchContext(event: {
    itemKey: 'territory' | 'customer', searchValue: {
      textValue: string,
      innerSearch: { itemKey: { eclEBS: string[], nlcSAP: string[] }, itemValue: string, itemCode: string }
    }
  }) {
    localStorage.setItem(appVariables.orders.title.salesOrgGUID, JSON.stringify(event.searchValue.innerSearch));
    this.ordersService.canReload = true;
    this.ordersService.sourceValueOfOrdersView$.next({
      search: {
        searchKey: event.itemKey,
        searchValue: event.itemKey === 'customer' ? { shipToNo: event.searchValue.textValue, salesOrg: event.searchValue.innerSearch.itemKey } :
          { territoryId: event.searchValue.textValue, systemId: '' }
      }
    });
    if (!(this.router.url.includes('customers'))) {
      this.router.navigate(['/orderStatus/customers']);
    }
  }

  navigateTo() {
    this.ordersService.canReload = false;
    this.router.navigate([this.ordersService.backArrowUrl]);
  }

  reset() {
    this.actions.next('reset');
  }

  close() {
    this.settingsSideNav.close();
    this.cd.detectChanges();
  }

  save() {
    this.actions.next('save');
  }
  navigateToHelpPage(urlHelp: string) {
    if (urlHelp) {
      window.open(urlHelp);
    }
  }
}


@Component({
  selector: 'dialog-content-example-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'dialog-content.html',
  styleUrls: ['./dialog-content.scss']
})
export class DialogContentExampleDialog {

  query_conversation: string;

  constructor(
    public dialogRef: MatDialogRef<DialogContentExampleDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }


  onNoClick(): void {
    this.dialogRef.close();
  }

  toggleText() {

    var points =
      document.getElementById("points");

    var showMoreText =
      document.getElementById("moreText");

    var buttonText =
      document.getElementById("textButton");

    if (points?.style.display === "none") {

      showMoreText!.style.display = "none";

      points.style.display = "inline";

      buttonText!.innerHTML = "Show More";
    }

    else {

      showMoreText!.style.display = "inline";

      points!.style.display = "none";

      buttonText!.innerHTML = "Show Less";
    }
  }

  showMoreShipto() {

    var incorrectShiptoPoints =
      document.getElementById("incorrectShiptoPoints");

    var incorrectShiptoMoreText =
      document.getElementById("incorrectShiptoMoreText");

    var incorrectShiptoButton =
      document.getElementById("incorrectShiptoButton");

    if (incorrectShiptoPoints!.style.display === "none") {

      incorrectShiptoMoreText!.style.display = "none";

      incorrectShiptoPoints!.style.display = "inline";

      incorrectShiptoButton!.innerHTML = "Show More";
    }

    else {

      incorrectShiptoMoreText!.style.display = "inline";

      incorrectShiptoPoints!.style.display = "none";

      incorrectShiptoButton!.innerHTML = "Show Less";
    }

  }
  showMoreLogistics() {

    var logisticsPoints =
      document.getElementById("logisticsPoints");

    var logisticsMoreText =
      document.getElementById("logisticsMoreText");

    var logisticsButton =
      document.getElementById("logisticsButton");

    if (logisticsPoints!.style.display === "none") {

      logisticsMoreText!.style.display = "none";

      logisticsPoints!.style.display = "inline";

      logisticsButton!.innerHTML = "Show More";
    }

    else {

      logisticsMoreText!.style.display = "inline";

      logisticsPoints!.style.display = "none";

      logisticsButton!.innerHTML = "Show Less";
    }

  }
  showMoreErrorScreen() {

    var errorScreenPoints =
      document.getElementById("errorScreenPoints");

    var errorScreenMoreText =
      document.getElementById("errorScreenMoreText");

    var errorScreenButton =
      document.getElementById("errorScreenButton");

    if (errorScreenPoints!.style.display === "none") {

      errorScreenMoreText!.style.display = "none";

      errorScreenPoints!.style.display = "inline";

      errorScreenButton!.innerHTML = "Show More";
    }

    else {

      errorScreenMoreText!.style.display = "inline";

      errorScreenPoints!.style.display = "none";

      errorScreenButton!.innerHTML = "Show Less";
    }

  }
  helpQues = '<b>HOW CAN I SEEK ASSISTANCE?</b>'
  helpAns = 'For any <b>requests</b>, <b>questions</b>, or <b>issues</b>, send an email or raise a ticket in service now:'
  userType1 = '<b>Email</b>'
  userType2 = '<b>Athena support ticket</b>'

  userEmail1 = '<a href="mailto:Ordertrackingsupport@ecolab.com">Ordertrackingsupport@ecolab.com</a>'
  userEmail2 = '<a target="_blank" href="https://ecolab.service-now.com/myecolab?id=sc_cat_item&sys_id=f6e771241be55498eef54377cc4bcbb0">ecolab.service-now.com</a>'

  

  alternateHelp = 'Alternatively, you may review the following self-help knowledgebase articles to resolve the issue on your own:'
  kbArticle1 = '<a target="_blank" href="https://ecolab.service-now.com/nav_to.do?uri=kb_knowledge.do?sys_id=92e1c3aa1b7fdd58640c32af034bcbd5">WhereIsMyOrder.ecolab.com (Athena) | Order Tracking - Overview</a>'
  kbArticle2 = '<a target="_blank" href="https://ecolab.service-now.com/nav_to.do?uri=kb_knowledge.do?sys_id=2b3143661b7fdd58640c32af034bcbf7">WhereIsMyOrder.ecolab.com (Athena) | Order Tracking - Frequently Asked Questions</a>'
  kbArticle3 = '<a target="_blank" href="https://ecolab.service-now.com/nav_to.do?uri=kb_knowledge.do?sys_id=fb61cf661b7fdd58640c32af034bcbf6">WhereIsMyOrder.ecolab.com (Athena) | Order Tracking access</a>'
  kbArticle4 = '<a target="_blank" href="https://ecolab.service-now.com/nav_to.do?uri=kb_knowledge.do?sys_id=eda1cfe61b7fdd58640c32af034bcbf0">WhereIsMyOrder.ecolab.com (Athena) | Order Tracking is not accessible</a>'
  escalationPoc = '<b>Escalation POCs</b>'
  escalationPocInfo = 'In case the request, question, or issue you reported is not getting expected traction / any urgency,<br> please escalate it to Product team lead at <a href="mailto:Ordertrackingsupport@ecolab.com">Ordertrackingsupport@ecolab.com</a>'
  prodOpsServiceLevel1 = '<a href="mailto:Ordertrackingsupport@ecolab.com">Ordertrackingsupport@ecolab.com</a><br>+91 9160217896'
  prodOpsServiceLevel2 = '<a href="mailto:jeff.kelly@ecolab.com">jeff.kelly@ecolab.com</a><br>+1 (612) 2207121'
  cdsServiceLevel2 = '<a href="mailto:tara.bauer@ecolab.com">tara.bauer@ecolab.com</a>'
  cdsServiceLevel1 = '<a href="mailto:ecolabcds@service-now.com">ecolabcds@service-now.com</a><br>+1-866-851-8670'
  itServiceLevel2 = '<a href="mailto:maritess.fria@ecolab.com">maritess.fria@ecolab.com </a>'
  itServiceLevel1 = '<a href="https://ecolab.service-now.com/nav_to.do?uri=%2Fkb_view.do%3Fsys_kb_id%3D4c59bf8fdbd28150f944176a48961929" target="_blank">Employee Self Service - IT Help Center Contact Information | ServiceNow Everywhere It Matters (service-now.com)</a>'
  productOpsNote = 'Note:<span style="font-size:0.8rem"> make sure to use of <b>EMEC</b> process (<a href="https://ecolab.service-now.com/nav_to.do?uri=%2Fkb_view.do%3Fsys_kb_id%3Da77adf941b37cd5098dba755624bcbe7%26sysparm_rank%3D1%26sysparm_tsqueryId%3D05ed5eb81b59d1946b328596624bcb80" target="_blanck">EMEC - Procedures - Critical and High priority cases</a>) if you recognize the issue may be happening to more than one Associate/Product outage is seen</span>'
  productOpsHoursTitle = 'Product Ops Operating Hours'
  productOpsHours = '9*5 – Monday to Friday, 10:30 PM Central Standard Time to 7:30 AM Central Standard Time + <b>Critical and High priority incidents are supported by 24*7</b>'
  serviceTeam1 = "To 'Update CRM User Profile' incident should be assigned to ServiceNow assignment group - <b>GBS-TCS-SAP-CRM</b>"
  serviceTeam2 = "To 'Assign CRM License in Active Directory' incident should be assigned to ServiceNow assignment group - <b>GBS-TCS-SAP-CRM</b>"
  serviceTeam3 = "In case 'Sales Territory Alignment is Not Correct' incident should be assigned to <br>ServiceNow assignment group - <b>GBS-TCS-SAP-CRM</b> (Nalco order) or <b>GBS-TCS-AZURE</b> (EBS order)"
  serviceNote = '<b>Note:</b> anything outside of Athena, you / Level 1 - IT Service Desk or CDS (DSS) Support will be required to reach out to respective support / Product Ops team e.g.,'
  whereIsMyOrderServiceNow = 'ServiceNow Service: <b>Where Is My Order</b>'
  whereIsMyOrderServiceNowAssignment = 'ServiceNow Assignment Group: <b>EDC-AthenaOST-Tier2</b>'
  productOpsSupport1 = 'Requests'
  productOpsSupport2 = 'Request for information'
  productOpsSupport3 = 'User access issues'
  productOpsSupport4 = 'Addition of new features in Product'
  productOpsSupport5 = 'Product enhancements'
  productOpsSupport6 = 'Platform enhancements/upgrade'
  productOpsSupport7 = 'Product availability'
  productOpsSupport8 = 'Product performance/latency issues'
  productOpsSupport9 = 'Break fix in the Product'
  productOpsSupport10 = 'Product defects'
  productOpsSupport11 = 'Any other Product issue/error'
  whatIsProductTeam = '<b>What is Product Team?</b>'
  productTeamAns = 'Product team has end to end ownership of WhereIsMyOrder.ecolab.com (Athena) | Order Tracking'
  productOpsContactLevel1 = '<a href="https://ecolab.service-now.com/nav_to.do?uri=%2Fkb_view.do%3Fsys_kb_id%3D4c59bf8fdbd28150f944176a48961929" target="_blank">Level 1 IT Service Desk</a> (available 24*7) - <b>all other Users</b>'
  productOpsContactLevel2 = '<a href="mailto:ecolabcds@service-now.com" target="_blank">Level 1 CDS (DSS) Support</a> (available Monday to Friday, 8 AM – 5 PM CST, +1-866-851-8670 select option #1 for afterhours voicemail) - <b>for Industrial Users</b>'
  productOpsContactAns = 'You can reach to Product Ops (Level 2 & Level 3) via:'
  productOpsContactQues = 'How to reach out to Product Ops (L2 & L3)?'
  territoryIssuesTitle = 'Self-help Knowledge Base Articles:'
  selfHelpContent = 'In case of any question / request / issue you may follow self-help knowledge base articles available in <a href="https://ecolab.service-now.com/sp/" target="_blank">ServiceNow</a> before reaching out to <b>Level 1 - IT Service Desk or CDS (DSS) Support</b>'
  issueResolution = 'Issue Resolution:'
  territoryIssuesOne = 'Incomplete territory mapping'
  territoryIssuesTwo = 'No territories assigned'
  territorycontent = 'In order to display correct #shipto details for a territory, we rely on the Informatica Database'
  territoryResolution = 'There could be issues in the CRM Regarding territory assignment, to rectify this please raise a ticket Service now to the below assignment group with User email ID & Expected Territories'
  territoryResolutionNalco = 'If Nalco Water or Food & Beverage User, escalate to GBS-TCS-MSDynamics-CRM/ TCS-SAP-CRMSD'
  territoryResolutionAzure = 'Else, assign the incident to GBS-TCS-AZURE/ TCS-SAP-CRMSD team'
  territoryResolutionCrm = 'If there are no issues in CRM, then there could be an issue with our data import, to rectify this'
  territoryResolutionOst = 'Raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  incorrectShiptoTitle = 'Incorrect #Shipto details for territory'
  incorrectShiptoIssues = 'Territory Related data mismatch / Incorrect'
  incorrectShiptocontent = 'In order to display correct #shipto details for a territory, we rely on the Informatica Database'
  incorrectShiptoResolution = 'There could be issues in the Informatica DB, to rectify this please raise a ticket (Service now) to the “GBS-TCS-INFORMATICA MDM “group with User email ID & Expected Territories'
  incorrectShiptoResolutionOst = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  logisticsSupportTitle = 'Logistics / Tracking data'
  logisticsIssues = 'Shipping data Not available'
  logisticscontent = 'In order to display correct Logistics / Tracking data for an order, we rely on 3rd party vendor'
  logisticsResolutionCloudera = 'There could be issues in the data delivery from the 3rd party, to rectify this please raise a ticket (Service now) to the “TCS-nonSAP-CLOUDERA “group with User email ID & Expected Territories'
  logisticsResolutionOst = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'
  errorScreenTitle = 'Error on screen'
  errorScreenIssuesOne = 'Something went wrong'
  errorScreenIssuesTwo = 'Error Message'
  errorScreencontentIssues = 'There may be technical issues'
  errorScreencontentIncognito = 'Try Incognito / private mode on their browsers'
  errorScreencontentIos = 'If user is on iOS device (iPhone/iPad) or using Safari, ask user to Prevent Cross-Site Tracking'
  errorScreencontentCrosssite = 'Settings > Safari > and under the "Privacy & Security" section, disable "Prevent Cross-Site Tracking"'
  errorScreenResolution = 'If the above does not resolve your issue raise a ticket to “IT-Global-Digital App Support-OST“ with User email ID & Expected Territories'

}
